import { createApp, defineComponent } from 'vue';
import type { DirectiveBinding, ComponentOptions } from 'vue';
import cropPic from './crop-pic.vue';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const imgDom = el.firstElementChild as HTMLImageElement;
    const component = defineComponent(cropPic as ComponentOptions);
    const componentInstance = createApp(component, {
      src: imgDom.src,
      handleCropChange: binding.value.handleCropChange,
      width: imgDom.width,
      height: imgDom.height,
    });
    componentInstance.mount(el);
  },
};
